export enum EVibesRoutes {
  /**
   * @deprecated
   */
  VIBES = 'Vibes'
  // PUBLIC_VIBES = 'Vibes.Public'
}
